import { render, staticRenderFns } from "./Ledger.vue?vue&type=template&id=03871c1a&scoped=true"
import script from "./Ledger.vue?vue&type=script&lang=js"
export * from "./Ledger.vue?vue&type=script&lang=js"
import style0 from "./Ledger.vue?vue&type=style&index=0&id=03871c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03871c1a",
  null
  
)

export default component.exports